module.exports = __webpack_public_path__ + "static/media/background.4e482120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/background.jpg
// module id = 633
// module chunks = 0